import React from 'react';
import OutOfOffice from '@fiverr-private/out_of_office';
import { useFreelancerPageContext } from '../../FreelancerPageContext';
import { useSellerVacation } from '../hooks/useSellerVacation';

export const VacationMessageBanner = () => {
    const { username, seller, isCurrentUser } = useFreelancerPageContext();
    const { isOnVacation, vacationMessage, vacationEndDate, isContactAllowed } = useSellerVacation();
    const displayName = seller?.user?.profile?.displayName;

    if (!isOnVacation) {
        return null;
    }

    const outOfOfficeProps = {
        username,
        user_id: seller.user.id,
        displayName,
        is_on_vacation: isOnVacation,
        end_date: vacationEndDate,
        message_for_buyer: vacationMessage,
        is_page_owner: isCurrentUser,
        allow_contact: isContactAllowed,
        vacation_status: isOnVacation ? 'active' : 'historic',
    };

    return (
        <section className="m-b-40">
            <OutOfOffice {...outOfOfficeProps} />
        </section>
    );
};
